import { IconWrapper } from '../runtime';
export default IconWrapper('triangle-up', false, function (h, props) {
  return h("svg", {
    "attrs": {
      "width": props.size,
      "height": props.size,
      "viewBox": "0 0 16 16",
      "fill": "none"
    }
  }, [h("path", {
    "attrs": {
      "d": "M11.3974 9.97612C11.6763 10.4224 11.3538 11 10.8258 11L5.1739 11C4.65395 11 4.33063 10.4377 4.59322 9.99104C5.59114 8.29358 6.32925 7.03806 7.33234 5.33181C7.58824 4.89652 8.21756 4.88772 8.48519 5.31598L11.3974 9.97612Z",
      "fill": props.colors[0],
      "vector-effect": "non-scaling-stroke"
    }
  })]);
});